import tree from './baobab';
import * as api from './api';

async function getSettings() {
    const response = await api.request(api.Method.GET, '/settings');
    tree.set('settings', response.payload);
}

async function updateSettings(settings: any) {
    console.log('updating settings', settings);
    await api.request(api.Method.POST, '/settings', settings);
}

async function getAvailableOverseerVersions() {
    const response = await api.request(api.Method.GET, '/overseerversions');
    tree.set('overseerVersions', response.payload);
}

export default {
    getAvailableOverseerVersions,
    getSettings,
    updateSettings
};
